
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sexleketoy/par",
      function () {
        return require("private-next-pages/sexleketoy/par/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sexleketoy/par"])
      });
    }
  